import { useNavigate } from "react-router-dom";

export default function GameCard({title,img, url}){

  const navigate = useNavigate();
  return (
    <div className="col-md-3 col-6" style={{ cursor: "pointer" }}>
      <div className="card game-card overflow-hidden" onClick={() => navigate(url)}>
        <img src={img} className="w-100" alt="" />
        <div className="p-2 text-center fw-bold">{title}</div>
      </div>
    </div>
  );
}